import { render, staticRenderFns } from "./advert-video.vue?vue&type=template&id=0e6fc870"
import script from "./advert-video.vue?vue&type=script&lang=js"
export * from "./advert-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports